import { apiService } from "./apiService";
import { endpoints } from "../config/endpoints";
import { pickBy } from "lodash";

export class DashboardService {
  static getDashboardScores({ params }) {
    const query = DashboardService.setQuery(params);
    return apiService.get(`${endpoints.scores}${query ? query : ""}`);
  }

  static getGMBAvgRatings({ from, to }) {
    return apiService.get(
      `${endpoints.avgGMBRatings}?created_at__gte=${from}&created_at__lt=${to}`
    );
  }

  static getDashboardCompetitionScores({ params }) {
    const query = DashboardService.setQuery(params);
    return apiService.get(
      `${endpoints.competitionScores}${query ? query : ""}`
    );
  }

  static setQuery(params) {
    const { createdAtGte, createdAtLte, scoreTypeIds } = params;
    let query = "";
    query = createdAtGte ? `?created_at__gte=${createdAtGte}` : "";
    query =
      createdAtLte && createdAtGte
        ? `${query}&created_at__lte=${createdAtLte}`
        : query;
    query =
      createdAtLte && createdAtGte && scoreTypeIds.length > 0
        ? `${query}&score_type_ids=${scoreTypeIds}`
        : query;
    return !createdAtGte && !createdAtLte && scoreTypeIds.length > 0
      ? `${query}?score_type_ids=${scoreTypeIds.toString()}`
      : query;
  }

  static setQueryParams({
    firstDateFrom,
    firstDateTo,
    secondDateFrom,
    secondDateTo,
    gmbAddressesIds = [],
    cities = [],
    groups = []
  }) {
    const params = {
      first_date_from: firstDateFrom,
      first_date_to: firstDateTo,
      second_date_from: secondDateFrom,
      second_date_to: secondDateTo,
      gmb_address_ids: gmbAddressesIds.join(","),
      cities: cities.join(","),
      groups: groups.join(",")
    };

    return pickBy(params);
  }

  static getReviewsStats(params) {
    return apiService.get(endpoints.dashboardReviewsStats, {
      params: DashboardService.setQueryParams(params)
    });
  }

  static getGmbAddressesStats(params) {
    return apiService.get(endpoints.dashboardGmbAddressesStats, {
      params: DashboardService.setQueryParams(params)
    });
  }

  static getInsights(params) {
    return apiService.get(endpoints.dashboardInsights, {
      params: DashboardService.setQueryParams(params)
    });
  }

  static getLocalPostsStats(params) {
    return apiService.get(endpoints.dashboardLocalPostsStats, {
      params: DashboardService.setQueryParams(params)
    });
  }
}
